export enum Appointment {
    MONDAY_AM = 'MONDAY_AM',
    MONDAY_PM = 'MONDAY_PM',
    TUESDAY_AM = 'TUESDAY_AM',
    TUESDAY_PM = 'TUESDAY_PM',
    WEDNESDAY_AM = 'WEDNESDAY_AM',
    WEDNESDAY_PM = 'WEDNESDAY_PM',
    THURSDAY_AM = 'THURSDAY_AM',
    THURSDAY_PM = 'THURSDAY_PM',
    FRIDAY_AM = 'FRIDAY_AM',
    FRIDAY_PM = 'FRIDAY_PM',
    SATURDAY_AM = 'SATURDAY_AM',
    SATURDAY_PM = 'SATURDAY_PM',
    SUNDAY_AM = 'SUNDAY_AM',
    SUNDAY_PM = 'SUNDAY_PM',
}
